import { FileDownloadType } from './interfaces'

export const fileDownload = ({ data, filename, mime }: FileDownloadType) => {
  const blob = new Blob([data], { type: mime || 'application/octet-stream' })

  const blobURL = window.URL.createObjectURL(blob)

  const tempLink: HTMLAnchorElement = document.createElement(
    'a'
  ) as HTMLAnchorElement

  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', filename)
  tempLink.setAttribute('target', '_blank')

  document.body.appendChild(tempLink)
  tempLink.click()

  // Fixes "webkit blob resource error 1"
  setTimeout(() => {
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobURL)
  }, 0)
}
